


import './App.css';
import Login from './Login';
import Cars from './Cars';
import Movements from './Movements';
import CarSummary from './CarSummary';
import CarSummarySelector from './CarSummarySelector';
import AuditLog from './AuditLog';
import { useState } from 'react';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [page, setPage] = useState('cars');
  const [selectedCarId, setSelectedCarId] = useState(null);

  // on mount, check for persisted user
  useState(() => {
    try {
      const raw = localStorage.getItem('authUser');
      if (raw) {
        const parsed = JSON.parse(raw);
        setUser(parsed);
        setLoggedIn(true);
      }
    } catch (e) {}
  });

  if (!loggedIn) {
    return <Login onLogin={(u) => { setUser(u); setLoggedIn(true); }} />;
  }

  const navButton = (key, label) => (
    <button
      onClick={() => setPage(key)}
      className={
        `px-4 py-2 rounded-lg font-medium transition-all duration-300 transform hover:scale-105 ` +
        (page === key 
          ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg' 
          : 'text-gray-700 hover:bg-gray-50 border border-gray-200'
        )
      }
    >
      {label}
    </button>
  );

  return (
    <div className="App min-h-screen bg-white" dir="rtl" style={{ fontFamily: 'Inter, Poppins, system-ui, -apple-system, Roboto, "Helvetica Neue", Arial' }}>
      <header className="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center gap-6">
          <div className="flex items-center gap-4 float">
           
            <div>
              <div className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                نظام إدارة النقل
              </div>
              <div className="text-sm text-gray-600">لوحة التحكم </div>
            </div>
          </div>
          
          <div className="mr-auto flex items-center gap-3">
            {navButton('cars', 'إدارة النقل')}
            {navButton('movements', 'جدول الحركات')}
            {navButton('summary', 'ملخص السيارات')}
            {navButton('audit', 'سجل الأحداث')}
          </div>
          
          <div className="flex items-center gap-4">
            <div className="text-sm font-medium text-gray-700 bg-gray-50 border border-gray-200 px-3 py-2 rounded-lg">
              مرحبا، {user?.username || 'المستخدم'}
            </div>
            <button 
              className="btn-secondary"
              onClick={() => { localStorage.removeItem('authUser'); setUser(null); setLoggedIn(false); }}
            >
              تسجيل خروج
            </button>
          </div>
        </div>
      </header>

      <main className={`w-full mx-auto px-4 sm:px-6 ${page === 'movements' ? 'max-w-[96rem] lg:px-4' : 'max-w-7xl lg:px-8'} py-8 bg-gray-50 min-h-screen`}>
        <div className="animate-in fade-in duration-500">
          {page === 'cars' && <Cars />}
          {page === 'movements' && <Movements />}
          {page === 'summary' && <CarSummarySelector />}
          {page === 'audit' && <AuditLog />}
        </div>
      </main>
    </div>
  );
}

export default App;
